class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0 || $(".js-top-about-items").length > 0){
      this.event();
    }
  }
  event(){
    this.aboutItems();
  }
  aboutItems(){
    const listEl = document.querySelector(".js-top-about-items");
    if (!listEl || typeof gsap === "undefined") return;

    const itemEls = Array.from(listEl.querySelectorAll(".p-top-about__item"));
    if (!itemEls.length) return;

    const diagramEl = listEl.closest(".p-top-about__diagram") || listEl;
    const glowEl = diagramEl.querySelector(".p-top-about__glow");
    const proxy = { turn: 0 };
    let centerX = 0;
    let centerY = 0;
    let orbits = [];

    const localCenter = (el, listRect) => {
      const rect = el.getBoundingClientRect();
      return {
        x: rect.left - listRect.left + rect.width / 2,
        y: rect.top - listRect.top + rect.height / 2,
      };
    };

    const measure = () => {
      gsap.set(itemEls, { x: 0, y: 0 });
      const listRect = listEl.getBoundingClientRect();

      if (glowEl) {
        const glowRect = glowEl.getBoundingClientRect();
        centerX = glowRect.left - listRect.left + glowRect.width / 2;
        centerY = glowRect.top - listRect.top + glowRect.height / 2;
      } else {
        centerX = listEl.clientWidth / 2;
        centerY = listEl.clientHeight / 2;
      }

      orbits = itemEls.map((itemEl) => {
        const origin = localCenter(itemEl, listRect);
        return {
          itemEl: itemEl,
          originX: origin.x,
          originY: origin.y,
          orbitRadius: Math.hypot(origin.x - centerX, origin.y - centerY),
          startAngle: Math.atan2(origin.y - centerY, origin.x - centerX),
        };
      });
    };

    const applyTurn = () => {
      const delta = proxy.turn * Math.PI * 2;
      orbits.forEach((orbit) => {
        const angle = orbit.startAngle - delta;
        gsap.set(orbit.itemEl, {
          x: centerX + orbit.orbitRadius * Math.cos(angle) - orbit.originX,
          y: centerY + orbit.orbitRadius * Math.sin(angle) - orbit.originY,
        });
      });
    };

    const bind = () => {
      measure();
      if (typeof ScrollTrigger === "undefined") return;
      gsap.registerPlugin(ScrollTrigger);
      const orbitTl = gsap.timeline({
        defaults: { ease: "none" },
        scrollTrigger: {
          trigger: diagramEl,
          start: "top bottom",
          end: "top center",
          scrub: 2,
          invalidateOnRefresh: true,
          onRefresh: () => {
            measure();
            applyTurn();
          },
        },
      });
      orbitTl.to(proxy, {
        turn: 0.25,
        onUpdate: applyTurn,
      });
      orbitTl.to(proxy, {
        turn: 0,
        onUpdate: applyTurn,
      });
      ScrollTrigger.refresh();
    };

    if (document.readyState === "complete") {
      bind();
    } else {
      window.addEventListener("load", bind, { once: true });
    }
  }
}
